var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mb-1"},[(_vm.markedAsFraud)?_c('badge',{attrs:{"type":"danger"}},[_vm._v("\n        Fraudulent\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }